import { useCreateWallet } from "@privy-io/react-auth/solana";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTransition } from "react";
import { WalletCards } from "lucide-react";

export const Route = createFileRoute("/onboarding/create-wallet")({
  component: CreateWallet,
});

function CreateWallet() {
  const [isLoading, startTransition] = useTransition();
  const { createWallet } = useCreateWallet();
  const navigate = useNavigate();

  const handleCreateWallet = async () => {
    startTransition(async () => {
      try {
        await createWallet();
        navigate({ to: "/home" });
      } catch (error) {
        console.error(error);
      }
    });
  };
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4 px-4">
      <div className="flex flex-col items-center justify-center">
        <h6 className="mt-4 text-lg text-center font-semibold">
          Failed to create wallet! :(
        </h6>
        <p className="text-center text-sm text-zinc-300">
          Sometimes it's just a glitch. you can try again by clicking the button
          below!
        </p>
      </div>
      <button
        onClick={async () => await handleCreateWallet()}
        className="rounded-lg font-semibold"
      >
        {!isLoading && (
          <>
            <span>Create Wallet</span>
            <WalletCards className="size-4 ml-2" />
          </>
        )}
      </button>
    </div>
  );
}
